function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.78,70.32c-72.95-10.21-114.27,31-212.24,34.82-97.39-8.46-134.63-51.46-208.4-44.71C77.77,67.7,16.59,173.29,34.4,279.42S160.82,445.53,216.26,445.53c44.31,0,83.39-18.22,133.9-22.31,50,6.45,87.23,26.46,131.44,28.54,55.31,2.61,169.47-52.14,197.49-157.19S656.26,81.3,577.78,70.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.78,70.32c-72.95-10.21-114.27,31-212.24,34.82-97.39-8.46-134.63-51.46-208.4-44.71C77.77,67.7,16.59,173.29,34.4,279.42S160.82,445.53,216.26,445.53c44.31,0,83.39-18.22,133.9-22.31,50,6.45,87.23,26.46,131.44,28.54,55.31,2.61,169.47-52.14,197.49-157.19S656.26,81.3,577.78,70.32Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-217"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 655.48,
    y1: 457.89,
    x2: 689.91,
    y2: 457.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.07,
    y1: 456.3,
    x2: 643.25,
    y2: 457.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 534.15,
    y: 89.87,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.49,
    y: 105.54,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.18,
    y: 105.54,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.8,
    y: 314.71,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.99 342.64 58.13 342.64 58.13 330.38 87.42 330.38 87.42 342.64 75.07 342.64",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.82,
    y: 330.38,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.23,
    y: 225.75,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "618.13 253.68 604.57 253.68 604.57 241.42 633.85 241.42 633.85 253.68 623.79 253.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.26,
    y: 241.42,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.89,
    y: 225.75,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.19 253.68 156.23 253.68 156.23 241.42 185.51 241.42 185.51 253.68 175.28 253.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.92,
    y: 241.42,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.41,
    y: 310.21,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.75,
    y: 325.87,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "659.35 325.87 666.73 325.87 666.73 338.13 637.44 338.13 637.44 325.87 652.07 325.87",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.85,
    y: 310.21,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "343.37 338.13 334.19 338.13 334.19 325.87 363.48 325.87 363.48 338.13 350.24 338.13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.88,
    y: 325.87,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "370.04 387.47 379.14 387.47 379.14 399.73 349.85 399.73 349.85 387.47 362.76 387.47",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.19,
    y: 403.14,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.88,
    y: 403.14,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.75,
    y: 387.47,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.08,
    y: 403.14,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "313.87 415.4 301.77 415.4 301.77 403.14 331.06 403.14 331.06 415.4 321.95 415.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.78,
    y: 105.54,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.11,
    y: 121.2,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.8,
    y: 121.2,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.39,
    y: 115.92,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.73,
    y: 131.59,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "107.8 131.59 117.7 131.59 117.7 143.85 88.42 143.85 88.42 131.59 101.33 131.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.78,
    y: 166.42,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.11,
    y: 182.09,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.8,
    y: 182.09,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.41,
    y: 341.61,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.75,
    y: 357.27,
    width: 29.29,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "651.67 369.53 637.44 369.53 637.44 357.27 666.73 357.27 666.73 369.53 656.52 369.53",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507,277s11.15,17.83,15.82,35.07c3.31,12.26,3.46,99.76,3.46,99.76s.23-135.35,16.84-163.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,186S536,211.87,531.48,238.76s-8.58,170.13-8.58,170.13c-.26-14,.67-141.65-3.81-163.8a165.93,165.93,0,0,0-12.66-38.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.92,214.7s13.46.63,19.74-9.48,2.16-19.76-3.75-20.47-8.48,6.6-10.67,3.1,6.29-10.11-3.21-16.18-13.92,2.64-16.93-.47S494.26,160,488,156.39s-9.2.87-12.67,1-14.4-5.74-18.76-1.12,6.07,15.82,1.17,16.15-6.9,9.89-2.91,16.08,16.8,8.63,14.3,11.86-14.74,3-9.76,10.25,21.92,7.7,24.36,8.55-7.8,2.74-6.07,9.5,15.8,7.6,24.85,3.25S509.92,214.7,509.92,214.7Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.08,169.13s28.59,18.69,38.84,45.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "469.68 182.22 488.84 184.09 484.17 168.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "485.1 204.19 504.27 204.19 505.67 186.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.35,191.8s-10.93.51-16-7.69-1.75-16.05,3-16.62,6.87,5.36,8.65,2.51-5.1-8.2,2.61-13.13,11.3,2.14,13.75-.38.68-9.13,5.77-12,7.47.71,10.28.83,11.69-4.66,15.23-.9-4.93,12.84-.95,13.1,5.6,8,2.36,13-13.64,7-11.61,9.63,12,2.46,7.92,8.33-17.79,6.25-19.77,6.94,6.33,2.22,4.93,7.71-12.83,6.17-20.17,2.64S549.35,191.8,549.35,191.8Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.87,154.81s-23.2,15.17-31.52,37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "582.01 165.43 566.45 166.95 570.25 154.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "569.49 183.27 553.93 183.27 552.79 169.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.6,289.65s8.86.41,13-6.24,1.42-13-2.47-13.48-5.58,4.35-7,2,4.14-6.66-2.12-10.66-9.17,1.74-11.15-.31-.55-7.4-4.68-9.75-6.06.57-8.35.67-9.48-3.78-12.35-.73,4,10.41.77,10.63-4.54,6.51-1.92,10.59,11.07,5.69,9.42,7.81-9.71,2-6.42,6.75,14.43,5.07,16,5.63-5.14,1.8-4,6.26,10.4,5,16.36,2.14S513.6,289.65,513.6,289.65Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,259.64s18.83,12.31,25.58,30",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "487.1 268.26 499.72 269.49 496.64 259.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "497.26 282.73 509.88 282.73 510.8 271.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.83,351.88s-11,.51-16.17-7.77-1.76-16.18,3.08-16.76,6.94,5.41,8.73,2.54-5.15-8.28,2.63-13.25,11.4,2.16,13.86-.39.69-9.2,5.83-12.12,7.53.72,10.37.84,11.79-4.7,15.36-.92-5,12.95-1,13.22,5.64,8.1,2.38,13.16-13.76,7.08-11.71,9.72,12.07,2.48,8,8.39-18,6.3-19.94,7,6.38,2.23,5,7.77-12.94,6.22-20.35,2.66S523.83,351.88,523.83,351.88Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.63,314.56s-23.41,15.3-31.8,37.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "556.78 325.28 541.09 326.81 544.91 313.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "544.15 343.27 528.45 343.27 527.3 329.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.89,254.94s-13.36-1.8-17.73-12.86,1.42-19.83,7.35-19.47,7.16,8,9.94,4.95-4.37-11.06,6.06-15.34,13.22,5.09,16.74,2.56,2.84-10.9,9.65-13.29,8.89,2.5,12.28,3.27,15.2-3.07,18.66,2.26-8.81,14.47-4,15.67,5,11,0,16.34-18.07,5.49-16.19,9.11,14,5.62,7.77,11.84-23,3.65-25.5,4,7.19,4.09,4.28,10.43-16.91,4.65-25-1.24S539.89,254.94,539.89,254.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.25,217.05s-31.47,13.27-46.36,37.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "585.29 230.18 566.1 228.59 573.54 213.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "566.18 249.03 547.33 245.61 549.04 228.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.37,406.1c-1,2.57-1.51,24.44-1.51,27.34,0,19.24,10.61,23.7,23.7,23.7s23.7-3.43,23.7-23.7c0-2.9-.55-24.77-1.5-27.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-217"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.77,
    y: 39.97,
    width: 132.46,
    height: 166.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "156.01 164.07 156.01 49.06 212.87 49.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.94 49.06 273.99 49.06 273.99 197.19 156.01 197.19 156.01 173",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "243.06 130.86 243.06 158.35 186.95 158.35 186.95 87.9 243.06 87.9 243.06 121.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chairs--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.92,350.82,224,454.94a1.49,1.49,0,0,0,1.48,1.28h0a1.49,1.49,0,0,0,1.48-1.67L214.55,351.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,338.53s16.21-1.8,30.86-.23c6.16.66,27.89,2.36,27.19,7.47s-5.33,7.19-6.26,7.19-87.71,6-89.1,4.64-2.78-4.64-1.86-6.5S171.65,338.53,171.65,338.53Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.35,265.71a2.33,2.33,0,0,0-2.61,2.87c3.49,14.66,19.34,80.8,21,82.49,1.91,1.9,9.91,5.71,13.34,5.33s20.19-5.71,32.39-16,20.19-21.34,19.43-28.2-5-12.95-8.76-13.71-19.06.38-32.39-3.81-24.39-11.05-30.48-19.43C116.72,269,112.8,266.32,109.35,265.71Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73,318l3.69,39.07-22.37,97.72a1.29,1.29,0,0,0,1.24,1.61h0a1.28,1.28,0,0,0,1.24-.95l25.81-97.89,13-.49v-2.65l-13.24-1-7.41-35.79a1,1,0,0,0-.86-.8h0A1,1,0,0,0,124.73,318Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.29,350.82,461.24,454.94a1.49,1.49,0,0,1-1.47,1.28h0a1.49,1.49,0,0,1-1.49-1.67l12.38-102.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.56,338.53s-16.21-1.8-30.86-.23c-6.16.66-27.89,2.36-27.19,7.47s5.34,7.19,6.26,7.19,87.71,6,89.1,4.64,2.79-4.64,1.86-6.5S513.56,338.53,513.56,338.53Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.86,265.71a2.34,2.34,0,0,1,2.62,2.87c-3.5,14.66-19.35,80.8-21,82.49-1.91,1.9-9.91,5.71-13.34,5.33s-20.19-5.71-32.38-16-20.2-21.34-19.44-28.2,5-12.95,8.77-13.71,19.05.38,32.38-3.81,24.39-11.05,30.49-19.43C568.49,269,572.42,266.32,575.86,265.71Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.49,318l-3.7,39.07,22.37,97.72a1.29,1.29,0,0,1-1.24,1.61h0a1.28,1.28,0,0,1-1.24-.95L550.87,357.6l-13-.49v-2.65l13.24-1,7.41-35.79a1,1,0,0,1,.86-.8h0A1,1,0,0,1,560.49,318Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-217"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.89 457.44 192.96 457.44 189.49 295.8 203.36 295.8 199.89 457.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.71 305.94 203.14 305.94 203.36 295.8 189.49 295.8 189.71 305.94",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "493.3 457.44 486.37 457.44 482.9 295.8 496.77 295.8 493.3 457.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.12 305.94 496.55 305.94 496.77 295.8 482.9 295.8 483.12 305.94",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.76,
    y: 283.46,
    width: 316.29,
    height: 16.83,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.76,
    y: 283.46,
    width: 316.29,
    height: 8.42,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.87,
    y: 283.46,
    width: 330.07,
    height: 6.4,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-217"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.28,214s3.94,3.58,5,3.94,3.1.83,3.1.83l2.27.48-5-7.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.03 187.15 386.46 235.79 401.15 229.32 370.2 185.57 340.03 187.15",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.84 188.87 374.72 221.54 392.89 219.2 369.15 187.11 344.84 188.87",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.91,207.34a12.37,12.37,0,0,1-1.12-1.88,25.1,25.1,0,0,1,.57-3.76c.17-.51.69-.69,1.14.34a5,5,0,0,1,.4,2.4,12,12,0,0,0,.46,1.76l-1.14,1.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.13,210.38s-2.22-2.58-2.22-3a21.77,21.77,0,0,1,1.35-3.1c.06-.18,3-.35,3.45-.53s1.46-.29,1.22.47a2.5,2.5,0,0,1-1.4,1.64,7.75,7.75,0,0,0-1.46.81l-.18.82.82,1.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.81,212.36s-2.49-2.88-2.49-3.41a26.13,26.13,0,0,1,1.5-3.47c.07-.2,3.34-.39,3.87-.59s1.64-.33,1.38.52a2.81,2.81,0,0,1-1.58,1.84,8.57,8.57,0,0,0-1.64.92l-.19.91.91,1.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.3,214.92a32.71,32.71,0,0,1-3-3.48,30.62,30.62,0,0,1,1.57-3.27s6.1-1,6.43-.92.52.46-.46,1.37a7.38,7.38,0,0,1-3,1.32c-.39.13-.46,1.83-.46,1.83l1.84,2.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,214.31a27.83,27.83,0,0,0-4.95,2.37c-1.94,1.3-5.17,3-5.17,3l-3.32,11.35a14,14,0,0,1,7.2,2.44c3.23,2.37,10.12,1.72,11.85.65s4.09-9.48,1.93-11.42S340.71,214.31,340.71,214.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.83,223.36l-6-1.94s-4.53-3-5.61-3.44a23.89,23.89,0,0,0-4.95-.43s-10.34,14.86-10.77,15.94-.65,3.45.86,3.88,5.17-.86,5.17-.86,3.45,1.72,5.6,1.29,8.62-5,8.62-5l7.54-.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.64,218.41s4.74,7.32,6.46,7.54,3.45-.86,2.15-3.23-2.8-6-3.66-8-4.31-1.93-5.82,1.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,229.52a3.26,3.26,0,0,0-.27,3.77c.53.89,1.12,1.82,1.34,1.82a2.16,2.16,0,0,0,2.1-2.24C355.68,231.39,354.33,227.6,352.62,229.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.09,232.27a3.28,3.28,0,0,0-.26,3.77c.52.89,1.12,1.81,1.34,1.81a2.16,2.16,0,0,0,2.1-2.24C353.15,234.14,351.81,230.34,350.09,232.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.18,235a2.66,2.66,0,0,0-.21,3c.43.72.91,1.47,1.08,1.47a1.75,1.75,0,0,0,1.7-1.81C349.66,236.54,348.57,233.48,347.18,235Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.62,236.22a2,2,0,0,0-.16,2.33c.32.55.69,1.12.83,1.12a1.33,1.33,0,0,0,1.29-1.38C346.51,237.38,345.68,235,344.62,236.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.6 218.38 328.86 233.1 323.63 232.88 326.82 217.01 331.6 218.38",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,215s-2.51,18.37-3.88,20-19.8-3.41-20.71-3.64,1.14-26.39,1.14-26.39S325.91,214.05,328,215Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,89.62s-3.35,7.77-3.35,10.85.27,7.64-.53,10-4.69,3.75-3.75,5.76,3.61,3.22,3.61,3.22,1.88,9.65,2.95,12.6,2.82,3.35,4.42,3.08,5.77-1.34,5.77-1.34l3.08,15.94,20.23-11.25-3.35-10.45s5.76-10.05-.4-24.12S399.74,81.45,390.49,89.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.16,105.06a2.33,2.33,0,0,1,3.18-1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.29,
    cy: 109.32,
    rx: 0.93,
    ry: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.82,121.64s5.23-.13,7.64-3.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,134.35s-23.06,14-23.92,15.09-1.51,8.19-1.51,8.19l28.87-19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,325.62s-1.88,13.63-1.17,17.38,23.48,73,23.72,75.38,2.35,13.16,2.35,13.16-4.7,8.22-5.64,11.51-5.17,6.81-6.81,8-7.05,3.29-7.75,4.23,1.66.75,3.18,1.08a53.49,53.49,0,0,0,7.15.09s6.58.24,8.46-.47,4.46-7.75,5.64-9.16a6.48,6.48,0,0,1,3.05-1.88l-2.11,12h3.28s2.35-9.63,3.29-12.92,2.12-5.16.71-8.45a49.12,49.12,0,0,0-4.23-7.28s-.94-26.31-.71-27.48-1.64-24.2-2.34-30.3-5.88-22.3-6.11-23.71,1.41-17.38,1.41-17.38Z",
    style: {
      fill: "#b8b8b8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.32,329.09s2.67,19.8,4.19,28.12,7.62,63.3,7.23,68.28a60.42,60.42,0,0,1-.86,7.07s-6.69,14-8.22,15.63-4.15,5.05-5.71,5.35-7.44,1.27-6.09,2.8,15.72,1.68,18.83.82,7.12-7.51,8.41-8.32l1.28-.82,1,8.86,3.39-.09s2.66-8.17,2.52-13.4-3.42-10.88-3.42-10.88,3.46-17.86,5.49-29.93,5.72-21.05,3.13-30.39a112.53,112.53,0,0,1-3.57-16.63c0-.78,1.54-28,1.54-28S412.2,332.57,405.32,329.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.31,443.39a22.44,22.44,0,0,0-1.81-7.52c-.34.12-.69.24-1.07.39-4.05,1.61-10.2,9.53-15.26,13.76a13.67,13.67,0,0,1-10.36,3.29l-.13-.08a2.13,2.13,0,0,1-.73.31c-1.56.31-7.44,1.27-6.09,2.8s15.72,1.68,18.83.82,7.12-7.51,8.41-8.32l1.28-.82,1,8.86,3.39-.09S431.45,448.62,431.31,443.39Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,249.79,385.15,271l-5.75,62.19S400.3,342,417.54,341s26.64-6,26.64-6-2.35-45.74-2.09-48.35,3.4-12.8.79-24.29-5.23-15.94-5.23-15.94S401.35,255.8,383.06,249.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,136.29s-28,18.32-31.46,22.63-11.42,25.21-11.42,28.87,4.74,41.58,4.74,41.58l-6.68,23.71s4.31,6.24,26.72,4.52,33.61-7.11,33.61-7.11S431.21,226.57,431,223.34s7.11-34,7.54-40.72-3.18-25-5.38-30.6A172.05,172.05,0,0,0,426,136.29Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,75.73s-8.53,3.28-8.31,6.35,4.81,11.6,8.53,15.1,14,11.59,14.88,18.82-1.09,14.22-3.94,14.44l-2.84.22s1.09,5.25,10.94,6.78,21,1.31,26.48-8.1,4.15-30.19-1.32-39.82-19-15.54-26.48-16.63S393.43,75.73,393.43,75.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.72,170.64a55,55,0,0,1,4.37-5.47,38.34,38.34,0,0,1,9.26-6.68l2.37-3.88,2.16.86s6-3.88,10.56-7.33a31.61,31.61,0,0,0,6.46-6.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,177.23s1.2-1.89,2.85-4.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46,160.74s-6.68,8.18-7.32,11S400,207.63,400,207.63s-3.24,0-3.67.87-1.07,6.68-1.07,6.68-1.73,1.93-2.59,2.15l-32.75,5.17,1.51,12.93s20.9,0,26.72-.65,13.35,0,17-1.51c5.38-1.07,9.91-6,9.91-6l2.91-7s11.31-29,11.74-34.77a22.5,22.5,0,0,0-.44-7.57",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,78.73s3.89,7.43,4.07,11.32-1.42,8.31-.89,11.49,3.89,4.42,3.18,6.54-3.89,2.83-3.89,2.83-1.59,7.25-2.82,11.49-5.31,4.77-7.25,4.77a32.14,32.14,0,0,1-6.37-1.41L290.3,138l-23.86-17.32,1.94-10.43,3.89-7.25s-5.12-11.49-.53-19.62,12.55-10.78,21.39-11.84S306.39,78.73,306.39,78.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.81,104.54a3.47,3.47,0,0,0,2.3,2.66,6.76,6.76,0,0,0,4.24-.71s-1.77,7.25,1.41,11.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,108.61s1.41,5.3,6,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.62,89.69s2.29-1.94,5.48.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.65,
    cy: 98.36,
    rx: 4.8,
    ry: 6.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.57,100c0,1.22-.48,2.21-1.06,2.21s-1.06-1-1.06-2.21.47-2.21,1.06-2.21S306.57,98.73,306.57,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.56,
    y1: 99.15,
    x2: 281.82,
    y2: 98.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.42,125.76a9.58,9.58,0,0,1-3-1.42c-1.06-.88-2.65-1.94-2.65-1.94l4.42,10.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,78.73S301.26,74,297,75.38s-5.48,3.53-3.54,7.77,1.24,8.31-.7,9.55-8.13,2.3-8.84,3.54a12.13,12.13,0,0,1-2.12,2.47s-1.59-4.77-4.25-3.36-3.35,6.9-1.76,9.19l-7.43,5.66s.36-8.48-2.47-15.2S261.66,73.43,267,69s12-3.53,14-5.3,1.77-5.84,8-6.37,8.84,4.07,11.49,5.13,3.71-2.65,8.13.35,8,7.25,6.54,11.67S306.39,78.73,306.39,78.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.07,379s-3.57,24.66-3.57,29.87-.54,21.48-.54,21.48-1.92,5.75-1.92,7.12.27,4.66.27,4.66l1.1,14.53h13.15s5.21-20.83,4.66-38.1-10.14-49.43-10.14-49.43Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.58,245.63s.67,32.05,2.7,39.48S255,301.64,255,304s3,30,5.06,37.46-5.74,30.37-3.71,43.53,7.76,46.24,7.76,46.24-1.35-.33-1.35,4.39v9.79l.34,11.47h14.51s-1-2.36,2.36-2.36,5.4,2,7.09,2.36,23.62,0,23.62,0,1.69-2.7,1-4.39-3-1.68-7.42-4.05-9.79-6.07-11.48-7.76-2.36-6.07-3.37-8.1-2.7-4.38-2.7-5.73,2-32.41,2-50.64,2.7-29.36,5.74-46.23,2.7-48.26,3-57.37,1-25,1-25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.41,142.18s5.74,6.24,4.75,10.48a28.59,28.59,0,0,0-.75,7.74s6,10,6.49,28.21,3.74,43.69,3.74,43.69l-5.74,12.48-7-13.73s2-33.2,2.25-41.44.5-15.23-.5-20.22a75.06,75.06,0,0,1-1.25-9.24l-4-14.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.77 116.8 295.05 138.62 291.42 152.41 262.04 123.89 264.77 116.8",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,123.89s-17.81,25-20.3,35.27-.75,29.45-.5,32,1.25,55.67,2.5,57.92,8.48,3,8.48,3h46.44s3.49-1.75,3.24-7.24-1-11.48-1-11.48.25-53.92-.25-61.16-9.23-23-9.23-23Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.48,312.9a2,2,0,0,1-2-2v-8.11A4.5,4.5,0,0,1,259,298.3h6.31a2,2,0,0,1,0,4H259a.49.49,0,0,0-.49.49v8.11A2,2,0,0,1,256.48,312.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,282.68s2.61,4,3.83,4.9,1.69,2.61,3.07,6a19.86,19.86,0,0,1,1.53,5.51,18,18,0,0,1,1.22,4c0,1.07-4.9,3.22-4.9,3.22s.15,2-.77,2.45a5.91,5.91,0,0,1-4,.46,23.5,23.5,0,0,1-3.68-2.91,17.78,17.78,0,0,1-4.44-.92c-2-.77-4.29-1.23-5.52-2.92s-1.68-2.91-1.22-6.89,2.75-13.18,2.75-13.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.53,275.78s.31,7.36,1.07,7.82a17.49,17.49,0,0,0,8,1.53,22.4,22.4,0,0,0,6.44-1.84l-.16-7.2S262.13,277.16,259.53,275.78Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,146.05s-7.52,15.32-7.8,22.29,3.07,46.8,3.07,63.23,3.62,41.51,5,44,4.74,3.06,7.24,3.06,10.59,1.39,12.26-2.23,0-40.67,0-46.8,9.47-41.51,5.85-62.4",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,298.3h-6.3a2,2,0,0,0-1.05.3V302a2,2,0,0,0,1.05.31h6.3a.49.49,0,0,1,.49.49v8.11a2,2,0,0,0,4,0v-8.11A4.49,4.49,0,0,0,284.66,298.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.55,
    y: 310.77,
    width: 82.09,
    height: 59.44,
    rx: 4.82,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.98,
    y1: 297.38,
    x2: 277.15,
    y2: 303.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.3463626b8ee1ade41901b34c21e90725.svg";
export { ForwardRef as ReactComponent };